<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.74986 2.00049C2.33565 2.00049 1.99986 2.33627 1.99986 2.75049C1.99986 3.1647 2.33565 3.50049 2.74986 3.50049L17.249 3.50049C17.6632 3.50049 17.999 3.1647 17.999 2.75049C17.999 2.33627 17.6632 2.00049 17.249 2.00049L2.74986 2.00049Z"
      fill="currentColor"
    />
    <path
      d="M5.99944 17.9994C5.44715 17.9994 4.99944 17.5516 4.99944 16.9994V6.99935C4.99944 6.44707 5.44715 5.99935 5.99944 5.99935H13.9994C14.5517 5.99935 14.9994 6.44707 14.9994 6.99935V16.9994C14.9994 17.5516 14.5517 17.9994 13.9994 17.9994H5.99944Z"
      fill="currentColor"
    />
  </svg>
</template>
